import styled from 'styled-components';

export const Wrapper = styled.div`
  font-size: 0.8rem;
  letter-spacing: 0.02rem;
  line-height: 1.05rem;
  margin: 8.4rem 0;
  text-transform: uppercase;
`;
